import { render, staticRenderFns } from "./integration-features-dialog.vue?vue&type=template&id=1fb9772a&scoped=true&"
import script from "./integration-features-dialog.vue?vue&type=script&lang=js&"
export * from "./integration-features-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb9772a",
  null
  
)

export default component.exports